import { FC } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from '@chakra-ui/react';

import webView from 'common/webView';
import SunshineIcon from 'components/_core/SunshineIcon';
import Tooltip from 'components/_core/Tooltip';

import { locales } from './locales';

interface ActivityInfoProps {
  type: 'SELLING' | 'SERVICE';
}

const ActivityInfo: FC<ActivityInfoProps> = ({ type }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const description =
    type === 'SELLING' ? locales.sellingTooltip : locales.serviceTooltip;

  if (webView.isInWebView) {
    return (
      <>
        <SunshineIcon
          color="grey.600"
          name="information"
          onClick={(event) => {
            event.preventDefault();
            onOpen();
          }}
          size="icon-24"
        />

        <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
          <DrawerOverlay />
          <DrawerContent margin={0}>
            <DrawerBody>{description}</DrawerBody>
          </DrawerContent>
        </Drawer>
      </>
    );
  }

  return (
    <Tooltip description={description}>
      <SunshineIcon color="grey.600" name="information" size="icon-24" />
    </Tooltip>
  );
};

export default ActivityInfo;
